import { BaseMeiucaService } from './MeiucaService'
import { env } from '@/lib/env'
import { Amenity, AmenitiesResponse } from '@/types/amenity'

class AmenityService extends BaseMeiucaService {
  /**
   * Get all available amenities
   * @returns Array of amenities with id, label and icon
   */
  async getAmenities(): Promise<Amenity[]> {
    const response = await this.get<AmenitiesResponse>('/venues/amenities')
    return response.data.data
  }
}

export const amenityService = new AmenityService({
  baseURL: env.API_URL,
  refreshEndpoint: '/v1/auth/refresh',
  cookiePrefix: '',
  debug: env.IS_DEVELOPMENT,
})
